import moment from 'moment';

import { TRANSACTION_TYPE_INCOME } from 'application/util/transaction.util';

export default class EventUtil {
    /* @ngInject */
    constructor(stringUtil) {
        this.stringUtil = stringUtil;

        this.EventRepeatUnit = {
            Daily: 'day',
            Weekly: 'week',
            Monthly: 'month',
            Yearly: 'year'
        };

        this.EventRepeatEndType = {
            Never: 'never',
            AfterOccurrence: 'occurrence',
            OnDate: 'date'
        };

        this.EventRepeatSelector = {
            OnlyThis: 'only-this',
            ThisAndAllFollowing: 'this-and-all-following'
        };
    }

    getValue(type, value) {
        return type === TRANSACTION_TYPE_INCOME ? value : -value;
    }

    isPast(timestamp) {
        return timestamp < moment().endOf('day').valueOf();
    }

    getRepeatingFrequencySummary(repeat) {
        if (repeat) {
            // TODO normalize unit
            return repeat.frequency > 1
                ? `Every ${repeat.frequency} ${this.stringUtil.pluralize(repeat.frequency, repeat.unit)}`
                : `Every ${repeat.unit}`;
        }

        return null;
    }

    getRepeatingEndSummary(repeat) {
        if (repeat && repeat.end) {
            return repeat.end.date
                ? `until ${moment(repeat.end.date).format('MMMM D YYYY')}`
                : `${repeat.end.occurrence} ${this.stringUtil.pluralize(repeat.end.occurrence, 'time')}`;
        }

        return null;
    }

    getRepeatingSummary(timestamp, repeat) {
        let date = moment(timestamp);
        let dateFormat = date.year() === moment().year() ? 'dddd, MMMM D' : 'dddd, MMMM D YYYY';

        return {
            dateSummary: date.format(dateFormat),
            repeatingSummary: [this.getRepeatingFrequencySummary(repeat), this.getRepeatingEndSummary(repeat)]
                .filter((summary) => summary && summary.length > 0)
                .join(', ')
        };
    }

    happenedOn(event, timestamp) {
        if (!event) {
            return false;
        }

        if (typeof event.transactionDate === 'string' && event.transactionDate.length > 0) {
            return event.transactionDate === moment(timestamp).format('YYYY-MM-DD');
        }

        return moment(timestamp).startOf('day').valueOf() <= event.timestamp && event.timestamp <= moment(timestamp).endOf('day').valueOf();
    }
}



// WEBPACK FOOTER //
// ./src/application/util/event.util.js